export const RECEIVE_PROMPT = 'RECEIVE_PROMPT';
export const RECEIVE_PROMPTS = 'RECEIVE_PROMPTS';

export const receivePrompt = (prompt) => ({
    type: RECEIVE_PROMPT,
    prompt
});

export const receivePrompts = (assessmentName, prompts) => ({
    type: RECEIVE_PROMPTS,
    assessmentName,
    prompts
});

export const fetchPrompt = (promptId) => (dispatch, getState) => {
    const prompts = getState().entities.prompts;
    const prompt = prompts[promptId];
    
    return dispatch(receivePrompt(prompt));
};